// extracted by mini-css-extract-plugin
export var productDetail = "productDetail-C1_";
export var productDetailCopy = "productDetailCopy-3ny";
export var brandBtn = "brandBtn-1G7";